import Rete from 'rete'
import { nanoid } from 'nanoid/async'

import { App } from '../../App'
import { RcnModal } from './RcnModal'
import CONST_SOCKET from '../../const/socket'
import { 
  removeNodes,
  addRcnSingleNodeToEditor,
  updateNodeConnections,
} from '../../utils/functions'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { 
    value: rcnData,
    isConfirmed: isClickedOkButton,  
  } = await RcnModal(oldData, node)

  if (rcnData && Object.values(rcnData).length > 0) {
    
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }
    
    Object.assign(node.data, rcnData)

    if ('newRcn' === rcnData.rcnPostbackIdValue) {
      if (node.outputs instanceof Map) {
        const otnOutput = node.outputs.get(CONST_SOCKET.RECURRING_NOTIFICATION_OUTPUT)
        if (otnOutput instanceof Rete.Output) {
          if (0 === otnOutput.connections.length) {
            attachOtnSingleAndChildrenToOtnNode(node)
          }
        }
      }
    }

    if ('newRcn' !== rcnData.rcnPostbackIdValue) {
      if (isClickedOkButton && node.rcnPostbackIdValueChangeStatus) {
        if (node.rcnSingleNodeChildrenComponents 
          && node.rcnSingleNodeChildrenComponents instanceof Map
        ) {
          const nodesList = node.rcnSingleNodeChildrenComponents.get('node-id-' + node.id)
          
          if (nodesList) {
            removeNodes(nodesList)
            node.rcnSingleNodeChildrenComponents.delete('node-id-' + node.id)
          }
        }
      }
    }

    node.update()
    updateNodeConnections(node)
  }


  return false
}

const attachOtnSingleAndChildrenToOtnNode = async (node) => {
  const otnSingleNodePosition = [node.position[0] + 360, node.position[1] + 40]
  const otnSingleNode = await addRcnSingleNodeToEditor(otnSingleNodePosition)

  const nodeList = [otnSingleNode]

  App.editor.connect(
    node.outputs.get(CONST_SOCKET.RECURRING_NOTIFICATION_OUTPUT),
    otnSingleNode.inputs.get(CONST_SOCKET.RCN_SINGLE_INPUT)
  )

  const componentsMap = new Map()
  componentsMap.set('node-id-' + node.id, nodeList)
  node.rcnSingleNodeChildrenComponents = componentsMap
}